"use strict";

(() => {
  const dialog = document.querySelector("#people-aaf-dialog");
  if (!dialog) return;
  const el = (name) => dialog.querySelector(`[data-aaf-${name}]`);
  let mode = "import",busy = false,preview = null,exportText = "",ownerId = null,generation = 0,filter = "all",onImported;
  const show = (name, visible) => {el(name).hidden = !visible;};
  function message(text, isError = false) {
    I18n.bind(el("status"), "textContent", () => text);
    el("status").classList.toggle("error", isError);
  }
  function selectedIndices() {
    return [...el("results").querySelectorAll("input:checked")].map((input) => Number(input.value));
  }
  function sync() {
    el("close").disabled = busy;
    const selected = selectedIndices().length;
    el("preview").disabled = busy || !el("text").value.trim();
    el("import").disabled = busy || !preview || !selected || selected > preview.available;
    I18n.bind(el("import"), "textContent", () => selected ? T("imports.importCount", { count: selected }) : T("interface.importar_personas"));
    el("copy").disabled = busy || !exportText;
    el("download").disabled = busy || !exportText;
    el("text").readOnly = busy || mode === "export";
    el("filters").querySelectorAll("button").forEach((button) => {button.disabled = busy;});
    el("results").querySelectorAll("input").forEach((input) => {input.disabled = busy;});
    I18n.bind(el("selection"), "textContent", () => preview ? T("imports.selection", { count: selected, available: preview.available }) : "");
    el("selection").classList.toggle("error", Boolean(preview && selected > preview.available));
    dialog.setAttribute("aria-busy", String(busy));
  }
  function reset() {
    generation++;
    busy = false;preview = null;exportText = "";
    el("text").value = "";I18n.replaceChildren(el("results"));
    filter = "all";
    I18n.clear(el("summary"), "textContent");I18n.clear(el("selection"), "textContent");
    message("");show("review", false);sync();
  }
  async function request(path, body) {
    const response = await I18n.fetch(`/api/people/aaf/${path}`, {
      cache: "no-store", ...(body ? { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(body) } : {})
    });
    const payload = await response.json().catch(() => ({}));
    if (!response.ok) throw new Error(payload.error || T("people_aaf.no_se_pudo_completar_la_operacion"));
    return payload;
  }
  async function run(action) {
    if (busy) return;
    const active = generation;
    busy = true;message("");sync();
    const isCurrent = () => generation === active && dialog.open;
    try {await action(isCurrent);}
    catch (error) {if (isCurrent()) message(() => error.message || T("people_aaf.no_se_pudo_completar_la_operacion"), true);} finally
    {if (isCurrent()) {busy = false;sync();}}
  }
  function renderPreview(data) {
    preview = data;
    filter = "all";
    const ready = data.rows.filter((row) => row.status === "ready").length;
    const duplicate = data.rows.filter((row) => row.status === "duplicate").length;
    const invalid = data.rows.filter((row) => row.status === "invalid").length;
    I18n.bind(el("summary"), "textContent", () => T("imports.preview", { count: data.rows.length, ready, duplicate, invalid }));
    const fragment = document.createDocumentFragment();
    for (const row of data.rows) {
      const item = document.createElement(row.status === "ready" ? "label" : "div");
      item.className = `aaf-person aaf-person-${row.status}`;
      item.dataset.status = row.status;
      if (row.status === "ready") {
        const checkbox = document.createElement("input");
        checkbox.type = "checkbox";checkbox.value = row.index;checkbox.checked = true;
        I18n.bind(checkbox, "@aria-label", () => T("people_aaf.importar_value", { v0: row.name }));item.append(checkbox);
      }
      const copy = document.createElement("div"),title = document.createElement("strong"),details = document.createElement("span");
      I18n.bind(title, "textContent", () => row.name || T("people_aaf.carta_de_la_linea_value", { v0: row.line }));
      I18n.bind(details, "textContent", () => row.message || `${row.birthDate.split("-").reverse().join("/")} · ${row.birthTime} · ${row.city}`);
      copy.append(title, details);item.append(copy);
      if (row.originalBirthTime && row.status === "ready") {
        const adjustment = document.createElement("span");
        adjustment.className = "aaf-time-adjustment";
        I18n.bind(adjustment, "textContent", () => T("people_aaf.seconds_adjustment", { original: row.originalBirthTime, saved: row.birthTime }));
        copy.append(adjustment);
      }
      const status = document.createElement("small");
      I18n.bind(status, "textContent", () => T(`imports.${row.status}`));
      item.append(status);fragment.append(item);
    }
    I18n.replaceChildren(el("results"), fragment);renderFilters();show("review", true);sync();
  }
  function applyFilter() {
    let visible = 0;
    for (const row of el("results").children) {
      row.hidden = filter !== "all" && row.dataset.status !== filter;
      if (!row.hidden) visible++;
    }
    el("filters").querySelectorAll("button").forEach((button) => {
      button.setAttribute("aria-pressed", String(button.dataset.filter === filter));
    });
    I18n.bind(el("empty"), "textContent", () => T("people_aaf.filter_empty"));
    show("empty", visible === 0);
    el("results").scrollTop = 0;
  }
  function renderFilters() {
    const fragment = document.createDocumentFragment();
    for (const status of ["all", "ready", "duplicate", "invalid"]) {
      const button = document.createElement("button");
      button.type = "button";
      button.dataset.filter = status;
      button.className = "aaf-filter";
      const count = status === "all" ? preview.rows.length : preview.rows.filter((row) => row.status === status).length;
      I18n.bind(button, "textContent", () => T("people_aaf.filter_" + status, { count }));
      button.setAttribute("aria-controls", "aaf-results");
      button.addEventListener("click", () => {filter = status;applyFilter();});
      fragment.append(button);
    }
    I18n.replaceChildren(el("filters"), fragment);
    applyFilter();
  }
  async function open(nextMode, callback) {
    mode = nextMode;onImported = callback;reset();
    I18n.bind(el("title"), "textContent", () => mode === "import" ? T("interface.importar_personas") : T("interface.exportar_mis_cartas"));
    show("guide", mode === "import");

    I18n.bind(el("description"), "textContent", () => mode === "import" ? T("people_aaf.pega_tus_cartas_en_formato_aaf_de_astro_com_o_meridian_gold_utiliza_solo_datos_que_te") : T("people_aaf.estas_son_las_personas_de_tu_cuenta_en_formato_aaf_el_archivo_contiene_datos_personal"));


    I18n.bind(el("label"), "textContent", () => mode === "import" ? T("interface.texto_de_tus_cartas_en_formato_aaf") : T("people_aaf.tus_cartas_en_formato_aaf"));
    I18n.bind(el("text"), "placeholder", () => mode === "import" ? T("people_aaf.pega_aqui_el_texto_que_empieza_por_a93_y_b93") : T("people_aaf.preparando_tus_cartas"));
    for (const name of ["preview", "import"]) show(name, mode === "import");
    for (const name of ["copy", "download"]) show(name, mode === "export");
    dialog.showModal();sync();
    if (mode === "import") {el("text").focus();return;}
    await run(async (isCurrent) => {
      message(() => T("people_aaf.preparando_tus_cartas"));
      const data = await request("export");
      if (!isCurrent()) return;
      if (!data.count) {message(() => T("people_aaf.todavia_no_tienes_personas_guardadas_en_tu_cuenta"));I18n.bind(el("text"), "placeholder", () => T("people_aaf.tu_lista_de_personas_esta_vacia"));return;}
      exportText = data.text;el("text").value = data.text;
      message(() => T("imports.exportReady", { count: data.count }) + (data.warnings.length ? `\n${data.warnings.join("\n")}` : ""));
    });
  }
  function invalidatePreview() {
    preview = null;I18n.replaceChildren(el("results"));show("review", false);message("");sync();
  }
  el("text").addEventListener("input", invalidatePreview);

  el("results").addEventListener("change", sync);
  el("preview").addEventListener("click", () => run(async (isCurrent) => {
    message(() => T("people_aaf.revisando_cartas_lugares_y_husos_horarios"));
    const data = await request("preview", { text: el("text").value, discardSeconds: true });
    if (!isCurrent()) return;
    renderPreview(data);message(() => T("people_aaf.revisa_la_lista_y_pulsa_importar_para_guardar_las_personas_seleccionadas"));
    el("summary").focus();
  }));
  el("import").addEventListener("click", () => run(async (isCurrent) => {
    message(() => T("people_aaf.guardando_las_personas_seleccionadas"));
    const data = await request("import", { text: el("text").value, indices: selectedIndices(), discardSeconds: true });
    if (!isCurrent()) return;
    preview = null;I18n.replaceChildren(el("results"));show("review", false);
    el("text").value = "";
    filter = "all";
    const success = T("imports.imported", { count: data.imported }) + (data.skipped ? " " + T("imports.skipped", { count: data.skipped }) : "");
    message(success);
    try {await onImported?.();}
    catch {if (isCurrent()) message(() => T("people_aaf.value_recarga_la_pagina_para_actualizar_la_lista_de_personas", { v0: success }));}
  }));
  el("copy").addEventListener("click", async () => {
    try {await navigator.clipboard.writeText(exportText);message(() => T("people_aaf.cartas_copiadas_al_portapapeles"));}
    catch {el("text").focus();el("text").select();message(() => T("people_aaf.seleccionamos_el_texto_usa_ctrl_c_o_la_opcion_copiar_de_tu_dispositivo"));}
  });
  el("download").addEventListener("click", () => {
    const url = URL.createObjectURL(new Blob([exportText], { type: "text/plain;charset=utf-8" }));
    const link = document.createElement("a");link.href = url;
    link.download = `astroanamnesis-cartas-${new Date().toISOString().slice(0, 10)}.aaf`;
    document.body.append(link);link.click();link.remove();
    setTimeout(() => URL.revokeObjectURL(url), 1000);
    message(() => T("people_aaf.archivo_aaf_descargado"));
  });
  el("close").addEventListener("click", () => dialog.close());
  dialog.addEventListener("cancel", (event) => {if (busy) event.preventDefault();});
  dialog.addEventListener("close", reset);
  window.PeopleAaf = { open, setUser(id) {if (id !== ownerId) {ownerId = id;dialog.close();reset();}} };
})();